import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    Paper,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getIsDeadLineParam, isValidDDMMYYYY } from "../../Utils";
import Form104ApplicationSchoolList from "./Form104ApplicationSchoolList";
import ParameterTooltip from "./ParameterTooltip";

const useStyles = makeStyles({
    container: {
        maxHeight: 250,
    },
    form104Container: {
        maxHeight: 500,
    },
    schoolBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    courseBox: {},
    courseItemBox: {
        background: "#ccc",
        margin: "5px 0",
    },
    selectComponent: {
        width: 320,
        marginRight: 10,
        height: 20,
        fontSize: "inherit",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: 0,
        boxShadow: "none",
        outline: "none",
    },
    selectInput: {
        borderBottom: "1px solid #ccc",
        borderRadius: 0,
    },
    selectMenuPaper: {
        maxHeight: 300,
        width: "auto",

        position: "absolute",
        left: 0,
        right: "auto",
    },
    selectMenuItem: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    selectPlaceholder: {
        fontStyle: "italic",
    },
    menuItemText: {
        maxWidth: "100%",
        width: "auto",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    bottomBorderOnly: {
        "&:before": {
            transition:
                "border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            borderBottom: "1px solid #ccc",
            left: 0,
            right: 0,
            bottom: 0,
            position: "absolute",
            width: "100%",
            content: '""',
            pointerEvents: "none",
        },
        "&:hover:not(.Mui-disabled):before": {
            borderBottom: `2px solid rgba(0, 0, 0, 0.87)`,
        },
        "&.Mui-focused:after": {
            borderBottom: `2px solid #1976D2`,
        },
        "&.Mui-error:after": {
            borderBottom: `2px solid #f44336`,
        },
        "&:after": {
            borderBottom: "0px solid transparent",
        },
        "&.MuiInputBase-root": {
            "& input": {
                padding: "8px 0",
            },
        },
    },
});

function ParameterTemplate({
    defaultValues,
    schoolOption,
    dataList,
    selectedForm,
    register,
    control,
    errors,
    removeSchool,
    removeCourse,
    appendCourse,
    appendSchool,
    removeParamer,
    appendParamer,
    setValue,
    getValues,
    trigger,
    schoolList,
    i18n: i18nInstance,
}) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const handleParameter = (item) => {
        let value = "";
        try {
            value = JSON.parse(item[1]);
        } catch (error) {
            value = item[1];
        }
        let flag = Object.prototype.toString.call(value).indexOf("Object") > -1;
        return flag;
    };

    const sortCourseArry = (data) => {
        let arrNum = data
            .filter(
                (item) =>
                    !isNaN(parseInt(item[1].toString().trim().substring(0.3)))
            )
            .sort((a, b) => {
                return (
                    parseInt(a[1].toString().trim().substring(0, 3)) -
                    parseInt(b[1].toString().trim().substring(0, 3))
                );
            });
        let arrChar = data.filter((item) =>
            isNaN(parseInt(item[1].toString().trim().substring(0.3)))
        );
        return arrNum.concat(arrChar);
    };

    return (
        <>
            <TableContainer
                component={Paper}
                className={
                    selectedForm == "104"
                        ? classes.form104Container
                        : classes.container
                }
            >
                <Table stickyHeader arial-label="parameter table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                align="center"
                                style={{
                                    fontWeight: "bold",
                                    width: "35%",
                                }}
                            >
                                {t("common.portal.item")}
                            </TableCell>
                            <TableCell
                                align="center"
                                style={{
                                    fontWeight: "bold",
                                    width: "65%",
                                }}
                            >
                                {t("common.portal.input")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedForm == "41" ? (
                            Object.entries(schoolOption).map((item) => (
                                <TableRow key={item[0]}>
                                    <TableCell
                                        align="center"
                                        style={{
                                            verticalAlign: "top",
                                            paddingTop: "23px",
                                        }}
                                    >
                                        {item[0]}
                                    </TableCell>
                                    <TableCell align="center">
                                        {Array.isArray(item[1]) ? (
                                            <>
                                                {item[1].length > 0 &&
                                                    item[1].map(
                                                        (schItem, key) => {
                                                            return (
                                                                <Box key={key}>
                                                                    <Box
                                                                        className={
                                                                            classes.schoolBox
                                                                        }
                                                                    >
                                                                        <InputLabel
                                                                            htmlFor={`schoolOption.${item[0]}.${key}.name`}
                                                                            style={{
                                                                                display:
                                                                                    "none",
                                                                            }}
                                                                        >
                                                                            {t(
                                                                                "common.portal.input"
                                                                            )}
                                                                        </InputLabel>
                                                                        <CustomTextField
                                                                            inputProps={{
                                                                                ...register(
                                                                                    `schoolOption.${item[0]}.${key}.name`
                                                                                ),
                                                                            }}
                                                                            control={
                                                                                control
                                                                            }
                                                                        />
                                                                        <IconButton
                                                                            onClick={() =>
                                                                                removeSchool(
                                                                                    item[0],
                                                                                    key
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                            aria-label="remove"
                                                                        >
                                                                            <RemoveCircleIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                    <Box
                                                                        className={
                                                                            classes.courseBox
                                                                        }
                                                                    >
                                                                        {JSON.stringify(
                                                                            schItem.course
                                                                        ) ==
                                                                        "{}"
                                                                            ? ""
                                                                            : sortCourseArry(
                                                                                  Object.entries(
                                                                                      schItem.course
                                                                                  )
                                                                              ).map(
                                                                                  ([
                                                                                      courseKey,
                                                                                      courseIndex,
                                                                                  ]) => {
                                                                                      return (
                                                                                          <>
                                                                                              <Box
                                                                                                  key={
                                                                                                      "course" +
                                                                                                      courseKey
                                                                                                  }
                                                                                                  className={
                                                                                                      classes.schoolBox
                                                                                                  }
                                                                                              >
                                                                                                  <Box
                                                                                                      className={
                                                                                                          classes.courseItemBox
                                                                                                      }
                                                                                                  >
                                                                                                      <InputLabel
                                                                                                          htmlFor={`schoolOption.${item[0]}.${key}.course.${courseKey}.0`}
                                                                                                          style={{
                                                                                                              display:
                                                                                                                  "none",
                                                                                                          }}
                                                                                                      >
                                                                                                          {t(
                                                                                                              "common.portal.input"
                                                                                                          )}
                                                                                                      </InputLabel>
                                                                                                      <CustomTextField
                                                                                                          inputProps={{
                                                                                                              ...register(
                                                                                                                  `schoolOption.${item[0]}.${key}.course.${courseKey}.0`
                                                                                                              ),
                                                                                                          }}
                                                                                                          control={
                                                                                                              control
                                                                                                          }
                                                                                                      />
                                                                                                      <InputLabel
                                                                                                          htmlFor={`schoolOption.${item[0]}.${key}.course.${courseKey}.1`}
                                                                                                          style={{
                                                                                                              display:
                                                                                                                  "none",
                                                                                                          }}
                                                                                                      >
                                                                                                          {t(
                                                                                                              "common.portal.input"
                                                                                                          )}
                                                                                                      </InputLabel>
                                                                                                      <CustomTextField
                                                                                                          inputProps={{
                                                                                                              ...register(
                                                                                                                  `schoolOption.${item[0]}.${key}.course.${courseKey}.1`
                                                                                                              ),
                                                                                                          }}
                                                                                                          control={
                                                                                                              control
                                                                                                          }
                                                                                                      />
                                                                                                  </Box>
                                                                                                  <IconButton
                                                                                                      onClick={() =>
                                                                                                          removeCourse(
                                                                                                              item[0],
                                                                                                              key,
                                                                                                              courseKey
                                                                                                          )
                                                                                                      }
                                                                                                      color="primary"
                                                                                                      aria-label="remove"
                                                                                                  >
                                                                                                      <RemoveCircleIcon />
                                                                                                  </IconButton>
                                                                                              </Box>
                                                                                          </>
                                                                                      );
                                                                                  }
                                                                              )}
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            onClick={() =>
                                                                                appendCourse(
                                                                                    item[0],
                                                                                    schItem,
                                                                                    key
                                                                                )
                                                                            }
                                                                        >
                                                                            {t(
                                                                                "common.parameterPages.addCourse"
                                                                            )}
                                                                        </Button>
                                                                    </Box>
                                                                </Box>
                                                            );
                                                        }
                                                    )}

                                                <Box
                                                    style={{
                                                        marginTop: "20px",
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() =>
                                                            appendSchool(
                                                                item[0]
                                                            )
                                                        }
                                                        aria-label="add"
                                                    >
                                                        {t(
                                                            "common.parameterPages.addSchool"
                                                        )}
                                                    </Button>
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <InputLabel
                                                    htmlFor={`schoolOption.${item[0]}`}
                                                    style={{
                                                        display: "none",
                                                    }}
                                                >
                                                    {t("common.portal.input")}
                                                </InputLabel>
                                                <CustomTextField
                                                    inputProps={register(
                                                        `schoolOption.${item[0]}`,
                                                        {
                                                            required:
                                                                t(
                                                                    "errorMsg.required"
                                                                ),
                                                        }
                                                    )}
                                                    error={errors?.[item[0]]}
                                                />
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <>
                                {Object.entries(dataList.parameter).map(
                                    (item) => (
                                        <TableRow key={item[0]}>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    verticalAlign: "top",
                                                    paddingTop: "23px",
                                                }}
                                            >
                                                {selectedForm == "103" &&
                                                item[0] === "schoolyear"
                                                    ? "School Year"
                                                    : selectedForm == "68" &&
                                                      item[0]?.includes(
                                                          "circularNumber"
                                                      )
                                                    ? item[0]?.includes("EN")
                                                        ? "circularNumberEN/GuidelineEN"
                                                        : "circularNumberTC/GuidelineTC"
                                                    : item[0]}
                                            </TableCell>
                                            <TableCell align="center">
                                                {selectedForm == "104" &&
                                                item[0] ===
                                                    "applicationSchoolList" ? (
                                                    <Form104ApplicationSchoolList
                                                        defaultValues={
                                                            defaultValues
                                                        }
                                                        setValue={setValue}
                                                    />
                                                ) : selectedForm == "106" &&
                                                  item[0] ===
                                                      "trcNameOption" ? (
                                                    <>
                                                        {Object.entries(
                                                            getValues(
                                                                "trcNameOption"
                                                            ) ||
                                                                defaultValues.trcNameOption ||
                                                                {}
                                                        ).map(
                                                            (
                                                                [key, trcItem],
                                                                index
                                                            ) => {
                                                                const totalItems =
                                                                    Object.keys(
                                                                        getValues(
                                                                            "trcNameOption"
                                                                        ) ||
                                                                            defaultValues.trcNameOption ||
                                                                            {}
                                                                    ).length;
                                                                return (
                                                                    <Box
                                                                        key={
                                                                            key
                                                                        }
                                                                        style={{
                                                                            display:
                                                                                "flex",
                                                                            justifyContent:
                                                                                "flex-end",
                                                                            alignItems:
                                                                                "center",
                                                                        }}
                                                                    >
                                                                        <Box>
                                                                            <InputLabel
                                                                                htmlFor={`trcNameOption.${key}.en`}
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                            >
                                                                                {t(
                                                                                    "Form106.parameter.centerEN"
                                                                                )}
                                                                            </InputLabel>
                                                                            <CustomTextField
                                                                                inputProps={register(
                                                                                    `trcNameOption.${key}.en`,
                                                                                    {
                                                                                        required:
                                                                                            t(
                                                                                                "errorMsg.required"
                                                                                            ),
                                                                                    }
                                                                                )}
                                                                                control={
                                                                                    control
                                                                                }
                                                                                defaultValue={
                                                                                    trcItem.en
                                                                                }
                                                                                placeholder={t(
                                                                                    "Form106.parameter.centerEN"
                                                                                )}
                                                                            />
                                                                            <InputLabel
                                                                                htmlFor={`trcNameOption.${key}.tc`}
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                            >
                                                                                {t(
                                                                                    "Form106.parameter.centerTC"
                                                                                )}
                                                                            </InputLabel>
                                                                            <CustomTextField
                                                                                inputProps={register(
                                                                                    `trcNameOption.${key}.tc`,
                                                                                    {
                                                                                        required:
                                                                                            t(
                                                                                                "errorMsg.required"
                                                                                            ),
                                                                                    }
                                                                                )}
                                                                                control={
                                                                                    control
                                                                                }
                                                                                defaultValue={
                                                                                    trcItem.tc
                                                                                }
                                                                                placeholder={t(
                                                                                    "Form106.parameter.centerTC"
                                                                                )}
                                                                            />
                                                                            <InputLabel
                                                                                htmlFor={`trcNameOption.${key}.sc`}
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                            >
                                                                                {t(
                                                                                    "Form106.parameter.centerSC"
                                                                                )}
                                                                            </InputLabel>
                                                                            <CustomTextField
                                                                                inputProps={register(
                                                                                    `trcNameOption.${key}.sc`,
                                                                                    {
                                                                                        required:
                                                                                            t(
                                                                                                "errorMsg.required"
                                                                                            ),
                                                                                    }
                                                                                )}
                                                                                control={
                                                                                    control
                                                                                }
                                                                                defaultValue={
                                                                                    trcItem.sc
                                                                                }
                                                                                placeholder={t(
                                                                                    "Form106.parameter.centerSC"
                                                                                )}
                                                                            />
                                                                        </Box>
                                                                        {totalItems >
                                                                            1 && (
                                                                            <IconButton
                                                                                onClick={() =>
                                                                                    removeParamer(
                                                                                        "trcNameOption",
                                                                                        key
                                                                                    )
                                                                                }
                                                                                color="primary"
                                                                                aria-label="remove"
                                                                            >
                                                                                <RemoveCircleIcon />
                                                                            </IconButton>
                                                                        )}
                                                                    </Box>
                                                                );
                                                            }
                                                        )}
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                appendParamer(
                                                                    "trcNameOption",
                                                                    {
                                                                        en: "",
                                                                        tc: "",
                                                                        sc: "",
                                                                    }
                                                                )
                                                            }
                                                            style={{
                                                                marginTop:
                                                                    "20px",
                                                            }}
                                                        >
                                                            {t(
                                                                "common.button.append"
                                                            )}
                                                        </Button>
                                                    </>
                                                ) : selectedForm == "106" &&
                                                  item[0] ===
                                                      "excludedScrnList" ? (
                                                    <>
                                                        {(
                                                            getValues(
                                                                "excludedScrnList"
                                                            ) ||
                                                            defaultValues.excludedScrnList ||
                                                            []
                                                        ).map(
                                                            (
                                                                scrnItem,
                                                                index
                                                            ) => {
                                                                const totalItems =
                                                                    (
                                                                        getValues(
                                                                            "excludedScrnList"
                                                                        ) ||
                                                                        defaultValues.excludedScrnList ||
                                                                        []
                                                                    ).length;

                                                                const schoolInfo =
                                                                    schoolList.find(
                                                                        (
                                                                            school
                                                                        ) =>
                                                                            school.scrn ===
                                                                            scrnItem
                                                                    );

                                                                let displayName =
                                                                    scrnItem;
                                                                if (
                                                                    schoolInfo
                                                                ) {
                                                                    if (
                                                                        i18n.language ===
                                                                        "en"
                                                                    ) {
                                                                        displayName =
                                                                            schoolInfo.schoolNameEn ||
                                                                            scrnItem;
                                                                    } else {
                                                                        displayName =
                                                                            schoolInfo.schoolNameTC ||
                                                                            scrnItem;
                                                                    }

                                                                    const duplicateCount =
                                                                        schoolList.filter(
                                                                            (
                                                                                s
                                                                            ) =>
                                                                                (i18n.language ===
                                                                                "en"
                                                                                    ? s.schoolNameEn
                                                                                    : s.schoolNameTC) ===
                                                                                (i18n.language ===
                                                                                "en"
                                                                                    ? schoolInfo.schoolNameEn
                                                                                    : schoolInfo.schoolNameTC)
                                                                        ).length;

                                                                    if (
                                                                        duplicateCount >
                                                                        1
                                                                    ) {
                                                                        displayName = `${displayName} - ${schoolInfo.scrn}`;
                                                                    }
                                                                }

                                                                return (
                                                                    <Box
                                                                        key={
                                                                            index
                                                                        }
                                                                        style={{
                                                                            display:
                                                                                "flex",
                                                                            justifyContent:
                                                                                "flex-end",
                                                                            alignItems:
                                                                                "center",
                                                                        }}
                                                                    >
                                                                        <Controller
                                                                            name={`excludedScrnList.${index}`}
                                                                            control={
                                                                                control
                                                                            }
                                                                            render={({
                                                                                field,
                                                                            }) => (
                                                                                <FormControl>
                                                                                    <Autocomplete
                                                                                        key={`school-select-${i18n.language}`}
                                                                                        {...field}
                                                                                        options={
                                                                                            schoolList
                                                                                        }
                                                                                        getOptionLabel={(
                                                                                            option
                                                                                        ) => {
                                                                                            if (
                                                                                                !option ||
                                                                                                !option.scrn
                                                                                            )
                                                                                                return "";
                                                                                            let optionDisplayName;
                                                                                            if (
                                                                                                i18n.language ===
                                                                                                "en"
                                                                                            ) {
                                                                                                optionDisplayName =
                                                                                                    (option.schoolNameEn ||
                                                                                                        option.scrn) +
                                                                                                    ` - ${option.scrn}`;
                                                                                            } else {
                                                                                                optionDisplayName =
                                                                                                    (option.schoolNameTC ||
                                                                                                        option.scrn) +
                                                                                                    ` - ${option.scrn}`;
                                                                                            }
                                                                                            return optionDisplayName;
                                                                                        }}
                                                                                        value={
                                                                                            schoolList.find(
                                                                                                (
                                                                                                    school
                                                                                                ) =>
                                                                                                    school.scrn ===
                                                                                                    field.value
                                                                                            ) ||
                                                                                            null
                                                                                        }
                                                                                        onChange={(
                                                                                            event,
                                                                                            newValue
                                                                                        ) => {
                                                                                            field.onChange(
                                                                                                newValue
                                                                                                    ? newValue.scrn
                                                                                                    : ""
                                                                                            );
                                                                                        }}
                                                                                        renderInput={(
                                                                                            params
                                                                                        ) => (
                                                                                            <TextField
                                                                                                {...params}
                                                                                                InputProps={{
                                                                                                    ...params.InputProps,
                                                                                                    classes:
                                                                                                        {
                                                                                                            root: classes.bottomBorderOnly,
                                                                                                        },
                                                                                                }}
                                                                                                className={
                                                                                                    classes.selectComponent
                                                                                                }
                                                                                                placeholder={t(
                                                                                                    "common.pleaseSelect"
                                                                                                )}
                                                                                                variant="standard"
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </FormControl>
                                                                            )}
                                                                        />
                                                                        {totalItems >
                                                                            1 && (
                                                                            <IconButton
                                                                                onClick={() =>
                                                                                    removeParamer(
                                                                                        "excludedScrnList",
                                                                                        index.toString()
                                                                                    )
                                                                                }
                                                                                color="primary"
                                                                                aria-label="remove"
                                                                            >
                                                                                <RemoveCircleIcon />
                                                                            </IconButton>
                                                                        )}
                                                                    </Box>
                                                                );
                                                            }
                                                        )}
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                appendParamer(
                                                                    "excludedScrnList"
                                                                )
                                                            }
                                                            style={{
                                                                marginTop:
                                                                    "20px",
                                                            }}
                                                        >
                                                            {t(
                                                                "common.button.append"
                                                            )}
                                                        </Button>
                                                    </>
                                                ) : handleParameter(item) ? (
                                                    <>
                                                        {Object.entries(
                                                            JSON.parse(item[1])
                                                        ).map(
                                                            ([
                                                                key,
                                                                itemChild,
                                                            ]) => {
                                                                return (
                                                                    <Box
                                                                        key={
                                                                            itemChild.id
                                                                        }
                                                                    >
                                                                        <InputLabel
                                                                            htmlFor={`${item[0]}.${key}`}
                                                                            style={{
                                                                                display:
                                                                                    "none",
                                                                            }}
                                                                        >
                                                                            {t(
                                                                                "common.portal.input"
                                                                            )}
                                                                        </InputLabel>
                                                                        <CustomTextField
                                                                            inputProps={{
                                                                                ...register(
                                                                                    `${item[0]}.${key}`
                                                                                ),
                                                                            }}
                                                                            control={
                                                                                control
                                                                            }
                                                                            defaultValue={
                                                                                itemChild
                                                                            }
                                                                            style={{
                                                                                width: "85%",
                                                                            }}
                                                                        />
                                                                        <IconButton
                                                                            onClick={() =>
                                                                                removeParamer(
                                                                                    `${item[0]}`,
                                                                                    `${key}`
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                            aria-label="remove"
                                                                        >
                                                                            <RemoveCircleIcon />
                                                                        </IconButton>
                                                                    </Box>
                                                                );
                                                            }
                                                        )}

                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                appendParamer(
                                                                    item[0]
                                                                )
                                                            }
                                                        >
                                                            {t(
                                                                "common.button.append"
                                                            )}
                                                        </Button>
                                                    </>
                                                ) : item[0] !==
                                                  "disableServo" ? (
                                                    <>
                                                        <InputLabel
                                                            htmlFor={item[0]}
                                                            style={{
                                                                display: "none",
                                                            }}
                                                        >
                                                            {t(
                                                                "common.portal.input"
                                                            )}
                                                        </InputLabel>
                                                        <CustomTextField
                                                            inputProps={{
                                                                ...register(
                                                                    item[0],
                                                                    {
                                                                        required:
                                                                            t(
                                                                                "errorMsg.required"
                                                                            ),
                                                                        validate:
                                                                            (
                                                                                value
                                                                            ) =>
                                                                                getIsDeadLineParam(
                                                                                    selectedForm,
                                                                                    item[0]
                                                                                ) ===
                                                                                    false ||
                                                                                isValidDDMMYYYY(
                                                                                    value
                                                                                ) ||
                                                                                t(
                                                                                    "errorMsg.deadlineFormat"
                                                                                ),
                                                                    }
                                                                ),
                                                                autoComplete:
                                                                    "off",
                                                            }}
                                                            error={
                                                                errors?.[
                                                                    item[0]
                                                                ]
                                                            }
                                                            placeholder={
                                                                getIsDeadLineParam(
                                                                    selectedForm,
                                                                    item[0]
                                                                ) === true
                                                                    ? "DD/MM/YYYY"
                                                                    : ""
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    <Controller
                                                        control={control}
                                                        name={item[0]}
                                                        defaultValue={
                                                            defaultValues?.[
                                                                item[0]
                                                            ]
                                                        }
                                                        render={({ field }) => (
                                                            <Box
                                                                style={{
                                                                    paddingLeft:
                                                                        "10rem",
                                                                }}
                                                            >
                                                                <RadioGroup
                                                                    aria-label="disableServo"
                                                                    value={
                                                                        field.value
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        field.onChange(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        );
                                                                    }}
                                                                    row
                                                                >
                                                                    <FormControlLabel
                                                                        value="true"
                                                                        control={
                                                                            <Radio />
                                                                        }
                                                                        label="True"
                                                                    />
                                                                    <FormControlLabel
                                                                        value="false"
                                                                        control={
                                                                            <Radio />
                                                                        }
                                                                        label="False"
                                                                    />
                                                                </RadioGroup>
                                                            </Box>
                                                        )}
                                                    ></Controller>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}
                            </>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <ParameterTooltip
                title={t(`common.parameterPages.formTooltip.${selectedForm}`)}
                formId={`Form${selectedForm.toString().padStart(3, "0")}`}
            />
        </>
    );
}

export default ParameterTemplate;
